import React, { Component, Fragment } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import BookingForm from "./BookingForm";

class EditBookingModal extends Component {

  render() {
    return (
      <Fragment>
        <Modal isOpen={this.props.open} toggle={this.props.onClose} size="xl">
          <ModalHeader toggle={this.props.onClose} className="bg-light">EDIT BOOKING</ModalHeader>
          <ModalBody>
            <BookingForm
              key={this.props.event.id}
              bookingDate={this.props.bookingDate}
              bookingTime={this.props.bookingTime}
              service={this.props.service}
              resources={this.props.resources}
              discountCodes={this.props.discountCodes}
              onSubmit={this.props.onSubmit}
              onCancel={this.props.onCancel}
              event={this.props.event}
              resourceType={this.props.resourceType}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default EditBookingModal;